import { createSelector } from 'reselect';

const selectDepartments = (state: any) => state.departments;


export const selectDepartmentsCurrentItem = createSelector([selectDepartments], (departments) => departments.current);

export const selectDepartmentsListItems = createSelector([selectDepartments], (departments) => departments.list);

export const selectDepartmentsItemById = (itemId: any) =>
    createSelector(selectDepartmentsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDepartmentsQueryItems = createSelector([selectDepartments], (departments) => departments.query);

export const selectDepartmentsCreatedItem = createSelector([selectDepartments], (departments) => departments.create);

export const selectDepartmentsUpdatedItem = createSelector([selectDepartments], (departments) => departments.update);

export const selectDepartmentsReadItem = createSelector([selectDepartments], (departments) => departments.read);

export const selectDeletedItem = createSelector([selectDepartments], (departments) => departments.delete);

export const selectDepartmentsSearchedItems = createSelector([selectDepartments], (departments) => departments.search);

export const selectDepartmentsItemsCount = createSelector([selectDepartments], (departments) => departments.count);

export const selectDepartmentsItemsFilter = createSelector([selectDepartments], (departments) => departments.filter);